import React from "react";
const Video = ({ videoSrcURL, ...props }) => (
  <div class="video-container">
    <iframe
      class="responsive-iframe"
      src={videoSrcURL}
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
    />
  </div>
);
export default Video;
